import { createContext, useContext } from 'react';
import { useOutletContext } from 'react-router-dom';

export const CheckinFlowContext = createContext(null);

export const CheckinFlowProvider = ({ children, value }) => {
  return <CheckinFlowContext.Provider value={value}>{children}</CheckinFlowContext.Provider>;
};

export const useCheckinFlowContext = () => {
  const context = useContext(CheckinFlowContext);
  const outletContext = useOutletContext();

  return {
    ...(outletContext || {}),
    ...(context || {})
  };
};
